import IModule from '../IModule';

const separator: IModule = {
  title: 'separator',
  icon: '<i class=\'vw-separator\'></i>'
};
export default separator;

